<template>
  <div>
    <div class="flex flex-col gap-4">
      <div class="mb-0">
        <h3 class="m-0 text-[16px] font-normal font-lato text-[#333333]">
          {{ isBefore == 1 ? 'Add images for the system before evaluation and fixing.' : 'Add images for the system after evaluation and fixing.' }}
        </h3>
      </div>
      <div class="flex items-center gap-1.5 laptop:gap-3">
        <button :disabled="images.length >= 8"
          class="group flex items-center gap-1.5 laptop:gap-3 px-1.5 laptop:px-2.5 py-1 rounded-[5px] cursor-pointer border-1 border-[#092E87] bg-[#092E87] disabled:bg-white laptop:bg-white laptop:hover:bg-[#092E87] laptop:disabled:hover:bg-white disabled:border-[#CCCCCC] disabled:cursor-not-allowed"
          @click="image">
          <span
            class="text-[14px] laptop:text-[16px] font-lato mobile:text-[#fff] laptop:text-[#092E87] laptop:group-hover:text-[#fff] group-disabled:hover:!text-[#CCCCCC] group-disabled:!text-[#CCCCCC]">Upload
            images</span>
          <img v-if="images.length < 8" src="../../assets/images/upload-icon.png" alt=""
            class="w-[25px] h-[25px] laptop:w-[30px] laptop:h-[30px] hidden laptop:block laptop:group-hover:!hidden">
          <img v-if="images.length < 8" src="../../assets/images/upload-hover-icon.png" alt=""
            class="w-[25px] h-[25px] laptop:w-[30px] laptop:h-[30px] block laptop:hidden laptop:group-hover:block">
          <img v-if="images.length >= 8" src="../../assets/images/disabled-cloud.png" alt=""
            class="w-[25px] h-[25px] laptop:w-[30px] laptop:h-[30px]">
        </button>
        <p class="m-0 mobile:text-[12px] tablet:text-[14px] laptop:text-[16px] text-[#FE5000]">(Maximum 8 images
          allowed)</p>
        <input type="file" ref="fileInput" class="hidden" accept="image/png,image/jpg,image/jpeg" @change="updateImageDisplay" />
      </div>
      <div class="relative w-full">
        <div ref="slider"
          class="flex gap-6 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden px-2 scroll-smooth"
          @scroll="handleScroll">
          <div v-for="(item, index) in images" :key="index" 
            class="relative flex-none h-[150px] rounded-[10px] overflow-hidden group w-[calc(49%-12px)] tablet:w-[calc(33%-12px)] laptop:w-[calc(24%-12px)] border border-[#eee]">
            <img :src="item.url" alt="Preview" class="w-full h-full object-cover select-none" />
            <div
              class="absolute inset-0 p-[10px] mobile:items-end laptop:items-center mobile:justify-end laptop:justify-center mobile:flex-col-reverse laptop:flex-row gap-3 flex laptop:hidden laptop:group-hover:flex transition laptop:bg-opacity-50 mobile:bg-transparent laptop:bg-[#000]">
              <!-- Delete -->
              <button
                class="w-[22px] h-[22px] tablet:w-[30px] tablet:h-[30px] rounded-full bg-[#FE5000] flex items-center justify-center text-white"
                @click.stop="deleteImage(item)">
                <img src="../../assets/images/delete-on-filled.svg" alt="icon"
                  class="w-[14px] h-[14px] tablet:w-[16px] tablet:h-[16px]" />
              </button>
              <!-- Zoom -->
              <button
                class="w-[22px] h-[22px] tablet:w-[30px] tablet:h-[30px] rounded-full bg-[#00338D] flex items-center justify-center text-white"
                @click.stop="openModal(index)">
                <img src="../../assets/images/zoom-in-fill.png" alt="icon"
                  class="w-[14px] h-[14px] tablet:w-[16px] tablet:h-[16px]" />
              </button>
            </div>
          </div>
        </div>
        <!-- Dots -->
        <div v-if="totalPages > 1"
          class="flex justify-center mt-3 gap-2 px-2 py-1 w-max mx-auto rounded-full border border-[#CCCCCC] bg-[#EFEFEF]">
          <span v-for="n in totalPages" :key="n" class="w-3 h-3 rounded-full cursor-pointer"
            :class="n - 1 === currentPage ? 'bg-[#FE5000]' : 'border border-[#CCCCCC] bg-[#fff]'"
            @click="goToPage(n - 1)"></span>
        </div>
      </div>
    </div>
    <!-- Modal Preview -->


    <ImagePreviewer v-if="isModalOpen" :images="images" :currentIndex="currentIndex" :isModalOpen="isModalOpen"
      @update:currentIndex="val => currentIndex = val" @close="isModalOpen = false"></ImagePreviewer>


  </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
import { mapActions, mapGetters } from "vuex";
import ImagePreviewer from "./ImagePreviewer.vue";
import { disableScroll } from "../../helpers/scrollHelper";

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from "v-viewer"

export default {
  components: {
    ImagePreviewer
  },
  props: ["isBefore"],

  data() {
    return {
      images: [],
      type: "",
      isModalOpen: false,
      currentIndex: 0,
      currentPage: 0,
      itemsPerPage: 4, // show 4 images per "page"
      isDotClick: false, // 👈 new flag
    };
  },
  computed: {
    ...mapGetters([
      "quoteDetail",
      "quoteImageUploaded",
      "quoteImages",
      "deleteQuoteImage",
    ]),
    totalPages() {
      return Math.ceil(this.images.length / this.itemsPerPage);
    },
  },

  watch: {
    deleteQuoteImage: function () {
      if (this.deleteQuoteImage) {
        this.updateDeletedQuoteImages();
        this.getImages();
      }
    },

    quoteImageUploaded: function () {
      this.$refs.fileInput.value = ''
      this.images[0].isLoading = false;

      this.images.shift();
      this.images.splice(0, 0, this.quoteImageUploaded);
    },

    quoteImages: function () {
      this.images = this.quoteImages;
    },
  },

  mounted() {
    this.getImages();
    this.updateItemsPerPage();
    window.addEventListener("resize", this.updateItemsPerPage);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.updateItemsPerPage);
  },

  methods: {
    ...mapActions([
      "uploadQuoteImage",
      "getQuoteImages",
      "deleteQuoteImages",
      "updateDeletedQuoteImages",
    ]),

    updateItemsPerPage() {
      if (window.innerWidth < 640) {
        this.itemsPerPage = 2; // mobile
      } else if (window.innerWidth < 1024) {
        this.itemsPerPage = 3; // tablet
      } else {
        this.itemsPerPage = 4; // desktop
      }
    },

    openModal(index) {
      const $viewer = viewerApi({
          options: {
            toolbar: {
              prev: true,
              next: true
            },
            navbar: false,
            title: false,
            url: 'url',
            movable: false,
            initialViewIndex: index
          },
          images: this.images
        })

      // this.isModalOpen = true;
      // this.currentIndex = index;
      // disableScroll()
    },

    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.images.length - 1; // loop to last
      }
    },
    nextImage() {
      if (this.currentIndex < this.images.length - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0; // loop to first
      }
    },
    handleScroll() {
      if (this.isDotClick) return;

      const slider = this.$refs.slider;
      const width = slider.clientWidth;

      // tolerance add kiya hai pixel drift ke liye
      this.currentPage = Math.round((slider.scrollLeft + width / 4) / width);
    },

    goToPage(page) {
      const slider = this.$refs.slider;
      const width = slider.clientWidth;

      this.isDotClick = true;
      this.currentPage = page;
      this.currentIndex = page * this.itemsPerPage;

      slider.scrollTo({
        left: page * width,
        behavior: "smooth",
      });
      // reset flag after scroll ends
      setTimeout(() => {
        this.isDotClick = false;
      }, 500); // adjust timing based on animation speed
    },


    deleteImage(item) {
      this.$dialog.show({
        title: "Delete Image",
        text: "Are you sure you want to delete this image?",
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.deleteQuoteImages({
            manual_quote_id: this.$route.params.id,
            id: item.id,
          });
        },
      });
    },

    getImages() {
      let params = {
        manual_quote_id: this.$route.params.id,
        is_before: this.isBefore,
      };
      this.getQuoteImages(params);
    },

    uploadImage(e) {
      const file = e.target.files[0];
      let formData = new FormData();
      formData.append("document", file);
      formData.append("manual_quote_id", this.$route.params.id);
      formData.append("is_before", this.isBefore);
      formData.append("index", 0);
      formData.append("timestamp", new Date().getTime());
      this.uploadQuoteImage(formData);
    },

    updateImageDisplay(e) {
      const fileSize = e.target.files[0].size / 1024 / 1024; // in MiB
      const file = event.target.files[0];
      // ✅ Check file type
      if (!["image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
        toast.error("Only PNG, JPG, and JPEG files are allowed!");
        this.$refs.fileInput.value = ''
        return;
      } else if (fileSize <= 10) {
        const file = e.target.files[0];
        let url = URL.createObjectURL(file);
        var obj = {
          isLoading: true,
          url: url,
        };

        this.images.splice(0, 0, obj);
        this.uploadImage(e);
      } else {
        toast.error("File size should not be greater than 10MB.");
        this.$refs.fileInput.value = ''
      }
    },

    image() {
      this.$refs.fileInput.click();
    },

    // optionClicked(data) {
    //   this.$refs.bottomSheet.close();
    //   if (data == 1) {
    //     this.type = "camera";
    //   } else if (data == 2) {
    //     this.type = "gallery";
    //   }
    // },

  },
};
</script>
<style>
.viewer-close {
  width: 36px;
  height: 36px;
  background: url('../../assets/images/gallery-close.svg') no-repeat center center !important;
  background-size: 40px 40px !important;
  opacity: 1 !important;
  top: 10px;
  right: 10px;
}

.viewer-close::before {
  content: none !important; /* default X hata do */
}
</style>
